<script>
import WishlistButton from '@phoenix/mixins/components/wishlist/WishlistButton';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';
export default {
  components: { PhxsgButton },

  mixins: [WishlistButton],

  props: {
    hasLabel: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    label() {
      return this.isInWishlist(this.reference) ? this.$t('Wishlist.removeProduct') : this.$t('Wishlist.addToWishlist');
    },
  },
};
</script>

<template>
  <phxsg-button
    :variant="hasLabel ? 'link' : null"
    :size="hasLabel ? 'sm' : null"
    :icon-only="!hasLabel"
    :aria-label="ariaLabel"
    :data-cy="dataCy"
    :data-tracking="trackingDatalayer"
    :icon="{ start: { id: icon } }"
    @click.prevent="toggleProduct({ reference, internalReference, showBanner })"
  >
    <template v-if="hasLabel" #default>{{ label }}</template>
  </phxsg-button>
</template>
